/** @format */

export const ROUTES = {
  //AUTH
  LOGIN: "/",

  // DASHBOARD
  DASHBOARD: "/dashboard",
  CREATE_USER:'/create-user',
  MANAGE_USER:"/manage-user",
  EDIT_USER:'/edit-user'
};
